// Media queries as defined by react-bootstrap 1.0.0-beta.17
// https://react-bootstrap.github.io/layout/grid/

export const screenWidths = {
	xs: 575,
	sm: 576,
	md: 768,
	lg: 992,
	xl: 1200,
};

export const mediaQueries = {
	xs: `@media(max-width: ${screenWidths.xs}px)`,
	sm: `@media(min-width: ${screenWidths.sm}px)`,
	md: `@media(min-width: ${screenWidths.md}px)`,
	lg: `@media(min-width: ${screenWidths.lg}px)`,
	xl: `@media(min-width: ${screenWidths.xl}px)`,
};

export default mediaQueries;
